(() => {
  const WORKER_URL =
    "https://location-stock-indicator.zac-43e.workers.dev/inventory";

  const SESSION_KEY = "warehouse_shipping_warning_seen";

  function getCustomerCountry() {
    return (
      window.Shopify?.country ||
      document.documentElement.lang?.split("-").pop() ||
      "US"
    ).toUpperCase();
  }

  function showWarning(title, message) {
    if (document.getElementById("warehouse-warning-modal")) {
      return;
    }

    const wrapper = document.createElement("div");
    wrapper.id = "warehouse-warning-modal";

    wrapper.innerHTML = `
      <div class="warehouse-warning-overlay">
        <div class="warehouse-warning-box">
          <h2>${title}</h2>
          <p>${message}</p>
          <button type="button" id="warehouse-warning-close">
            Continue
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(wrapper);

    document
      .getElementById("warehouse-warning-close")
      .addEventListener("click", () => {
        wrapper.remove();
      });

    wrapper
      .querySelector(".warehouse-warning-overlay")
      .addEventListener("click", (event) => {
        if (
          event.target.classList.contains(
            "warehouse-warning-overlay"
          )
        ) {
          wrapper.remove();
        }
      });

    document.addEventListener(
      "keydown",
      function closeEscape(event) {
        if (event.key === "Escape") {
          wrapper.remove();
          document.removeEventListener(
            "keydown",
            closeEscape
          );
        }
      }
    );
  }

  function addStyles() {
    if (
      document.getElementById(
        "warehouse-warning-styles"
      )
    ) {
      return;
    }

    const style = document.createElement("style");
    style.id = "warehouse-warning-styles";

    style.textContent = `
      .warehouse-warning-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,.55);
        display:flex;
        align-items:center;
        justify-content:center;
        z-index:999999;
        padding:20px;
      }

      .warehouse-warning-box {
        background:white;
        max-width:480px;
        width:100%;
        padding:30px;
        border-radius:12px;
        text-align:center;
      }

      .warehouse-warning-box button {
        margin-top:20px;
        padding:12px 24px;
        background:#111;
        color:white;
        border:0;
        border-radius:6px;
        cursor:pointer;
      }
    `;

    document.head.appendChild(style);
  }

  async function checkVariant(variantId) {
    if (
      sessionStorage.getItem(SESSION_KEY)
    ) {
      return;
    }

    try {
      const country =
        getCustomerCountry();

      const response = await fetch(
        `${WORKER_URL}?variant=${variantId}&country=${country}`
      );

      const data =
        await response.json();

      if (
        data.warning &&
        data.warning.show
      ) {
        sessionStorage.setItem(
          SESSION_KEY,
          "true"
        );

        showWarning(
          data.warning.title,
          data.warning.message
        );
      }
    } catch (error) {
      console.error(
        "Warehouse warning error:",
        error
      );
    }
  }

  function monitorCartAdds() {
    const originalFetch =
      window.fetch;

    window.fetch = async function (...args) {
      const response =
        await originalFetch.apply(
          this,
          args
        );

      try {
        const url =
          args[0]?.url ||
          args[0];

        if (
          typeof url === "string" &&
          url.includes("/cart/add")
        ) {
          const clone =
            response.clone();

          const data =
            await clone.json();

          if (
            data &&
            data.variant_id
          ) {
            setTimeout(() => {
              checkVariant(
                data.variant_id
              );
            }, 300);
          }
        }
      } catch (e) {
        // Ignore non-cart requests
      }

      return response;
    };
  }

  addStyles();
  monitorCartAdds();

})();